export default "__VITE_ASSET__aSJ_4XHW__"